module.exports = __webpack_public_path__ + "static/media/sample-content.751572cd.jpg";